<div [ngClass]="'wrapper flex flex--row ' + content.subjectTaxonomyTags" *ngIf="content$ | async as content">
  <fcom-heading-tag [level]="headerLevel" extraClasses="ps-small-b nordic-blue-900-text text-icon-primary title">
    {{ content.teaserTitle }}
  </fcom-heading-tag>
  <div class="font-body-1 nordic-blue-900-text text-icon-primary text font-body-medium">
    <div [innerHTML]="content.teaserText | finSafe: 'html'"></div>
    <a
      *ngIf="content.target?.url && content.linkText"
      [finLink]="content.target.url"
      class="flex flex--middle nordic-blue-900-text text-icon-primary bold-type no-underline pr-xxsmall-t font-body-1 underline-hover font-body-medium-bold"
    >
      {{ content.linkText }}
      <fcom-icon
        class="editorial-category-link-icon nordic-blue-900-text text-icon-primary icon-small"
        [name]="SvgLibraryIcon.ARROW_RIGHT"
      />
    </a>
  </div>
</div>
